import { render, staticRenderFns } from "./Claims.vue?vue&type=template&id=323c13e6&scoped=true&"
import script from "./Claims.vue?vue&type=script&lang=ts&"
export * from "./Claims.vue?vue&type=script&lang=ts&"
import style0 from "./Claims.vue?vue&type=style&index=0&id=323c13e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c13e6",
  null
  
)

export default component.exports